import { SponsormanStatus } from 'EstraSponsor'

// Msw data config is an object stored in local storage to configure wich data will be returned from handlers
// This config is read in the handlers and data is returned accordingly

export type MswDataConfig = {
  status: SponsormanStatus
}

const localStorageMswConfigDataName = 'msw_data_config'

export const storeMswDataConfigToLocalStorage = (data: MswDataConfig): void => {
  localStorage.setItem(localStorageMswConfigDataName, JSON.stringify(data))
}

export const removeMswDataConfigToLocalStorage = (): void => {
  localStorage.removeItem(localStorageMswConfigDataName)
}

export const getMswDataConfigFromLocalStorage = (): MswDataConfig | null => {
  try {
    const data = localStorage.getItem(localStorageMswConfigDataName)
    return data ? JSON.parse(data) : null
  } catch {
    console.error('Error while retrieving Msw Scene from local storage')
    return null
  }
}
